import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EIcons } from '@passer-technologies/components';

@Component({
  selector: 'app-box-text',
  templateUrl: './box-text.html',
  styleUrls: ['./box-text.scss'],
  standalone: false
})
export class BoxTextComponent {
  @Input() classDiv: string;
  @Input() icon: EIcons;
  @Input() iconClass: string = '';
  @Input() iconColor = 'primary';
  @Input() iconSize = 'small';
  @Input() text: string;
  @Input() classText: string;

  @Input() toolText: string;
  @Input() classToolText: string;
  @Output() ClickAction = new EventEmitter<void>();

  clickAction(): void {
    this.ClickAction.emit();
  }
}
